(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goallfit-whey"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('goallfit-whey'))customElements.define('goallfit-whey',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.addEventListener('change',event=>{if(!event.target.matches('input[type=radio]'))return;const flavor=event.target.value;this.querySelectorAll('[data-panel],[data-visual],[data-ingredients]').forEach(el=>{el.hidden=(el.dataset.panel||el.dataset.visual||el.dataset.ingredients)!==flavor});this.querySelector('[role=status]').textContent='';});
this.addEventListener('submit',async event=>{if(!event.target.matches('.gaf-form'))return;event.preventDefault();if(this.busy)return;const selected=this.querySelector('input[type=radio]:checked')?.value;const panel=Array.from(this.querySelectorAll('[data-panel]')).find(el=>el.dataset.panel===selected);const form=panel?.querySelector('.gaf-form');if(!form||!form.reportValidity())return;const button=event.submitter;if(button?.disabled)return;const status=this.querySelector('[role=status]');const checkout=button?.name==='checkout';this.busy=true;const buttons=Array.from(this.querySelectorAll('button'));const original=buttons.map(b=>b.disabled);buttons.forEach(b=>b.disabled=true);status.textContent=status.dataset.adding;
try{const response=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(form.elements.id.value),quantity:Number(form.elements.quantity.value)}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||status.dataset.error);window.location.assign(checkout?this.dataset.cart+'/checkout':this.dataset.cart);}catch(error){status.textContent=error.message||status.dataset.error;buttons.forEach((b,i)=>b.disabled=original[i]);this.busy=false;}});
}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
